import React, { useEffect } from 'react';
import { Button, Typography, Grid } from '@material-ui/core';
import Box from '@mui/material/Box';
import { logFirebaseEvent } from '../../firebase';
import { P2P_NEW_INVESTOR_DASHBOARD_VIEW } from '../../firebase/constant';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import EarnIcon from '../../../../utils/assests/new-earn-icon.png';

const NewUser = (props: any) => {
  useEffect(() => {
    logFirebaseEvent(P2P_NEW_INVESTOR_DASHBOARD_VIEW);
  }, []);

  const { addMoney } = props;
  return (
    <Card className='redBorder'>
      <CardContent className='earnCard'>
        <Grid container spacing={0} alignItems='center'>
          <Grid item xs={7}>
            <span className='eutText'> Earn up to</span>
            <Typography>
              <span className='pValue'> 9.25%</span>
            </Typography>
          </Grid>
          <Grid item xs={5}>
            <img width='100%' src={EarnIcon} alt='' />
          </Grid>
        </Grid>
        <Box className='buttonGrid'>
          <Button
            variant='contained'
            className='btnBlue'
            onClick={() => addMoney()}
          >
            Invest now
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default NewUser;
